export default __webpack_public_path__ + "static/media/apo_eugen.d9b62d52.png";